// 登陆
export const LOGIN_API_KEY = "login";

// 注册
export const REGISTERE_API_KEY = "registere";
